// extracted by mini-css-extract-plugin
export default {"Order":"Order_Order__7QptE","Info":"Order_Info__4sRj7","Info__icon":"Order_Info__icon__LD4lj"};